var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrivedDamaged(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "48px",
    viewBox: "0 0 44 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-damaged",
    transform: "translate(1.000000, 1.000000)",
    stroke: "currentColor",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path-2",
    strokeLinejoin: "round",
    points: "20.7802098 46 42 33.9322527 42 11.5 20.873996 0 2.44249065e-15 11.5677473 2.44249065e-15 34"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 23.5,
    x2: 21,
    y2: 45.5,
    id: "Line-4",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 11,
    y1: 17,
    x2: 30.75,
    y2: 5.75,
    id: "Line-5",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.5,
    y1: 30.5,
    x2: 4.5,
    y2: 30.5,
    id: "Line-6",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    points: "10 17 14 30.5 7 24.5 11 36.5"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 21,
    x2: 30.5,
    y2: 31.5,
    id: "Line-7",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41,
    y1: 28,
    x2: 35,
    y2: 34,
    id: "Line-7-Copy",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 31.5,
    y1: 26,
    x2: 39.5,
    y2: 34,
    id: "Line",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 34,
    y1: 22,
    x2: 41,
    y2: 29,
    id: "Line-Copy",
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path-3",
    points: "0 11.5 21 23 42 11.5"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrivedDamaged);
export default __webpack_public_path__ + "static/media/arrived-damaged.5acaab0c4833b19807871ca8bf969fdc.svg";
export { ForwardRef as ReactComponent };